import { graphql } from "@/lib/gql/__generated__";

export const SEND_SAMPLE_EMAIL_RESERVATION_UPDATED_MUTATION = graphql(`
	mutation TestEmailReservationUpdated($input: TestEmailInput!) {
		testEmailReservationUpdated(input: $input) {
			userErrors
			status
		}
	}
`);
